<header class="header-inner" (click)="closeProfileMenu()">
  <!-- Search Input -->
  <div class="header-left">
    <!-- Mobile Menu Toggle -->
    <button
      class="mobile-menu-toggle"
      (click)="onToggleMobileMenu(); $event.stopPropagation()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </svg>
    </button>

    <!--<div class="search-bar-wrapper">
      <svg
        class="search-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        placeholder="Search jobs, candidates..."
        [(ngModel)]="searchVal"
        (ngModelChange)="onSearchChange()"
      />
    </div>-->
  </div>

  <!-- Action items & Profile -->
  <div class="header-right">
    <!-- Notification bell -->
    <button class="notification-btn">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <span class="notification-badge"></span>
    </button>

    <!-- Profile trigger -->
    <div class="profile-selector-container">
      <button class="profile-trigger-btn" (click)="toggleProfileMenu($event)">
        <div class="avatar-badge" [class.has-logo]="!!companyProfile?.logo_url">
          <img
            *ngIf="companyProfile?.logo_url"
            [src]="getLogoUrl(companyProfile.logo_url)"
            alt="Company Logo"
            class="company-logo-avatar"
          />
          <span *ngIf="!companyProfile?.logo_url">
            {{
              companyProfile?.company_name
                ? companyProfile.company_name[0]
                : userDetail
                  ? userDetail.first_name[0]
                  : "C"
            }}
          </span>
        </div>
        <div class="profile-details-text" *ngIf="userDetail">
          <span class="profile-company">
            {{
              companyProfile?.company_name ||
                userDetail.first_name + " " + userDetail.last_name
            }}
          </span>
          <span class="profile-user-email">
            {{ userDetail.phone_email }}
          </span>
        </div>
        <svg
          class="chevron-down-icon"
          [class.rotated]="showProfileMenu"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <!-- Dropdown Popup -->
      <div
        class="profile-dropdown-menu"
        *ngIf="showProfileMenu"
        (click)="$event.stopPropagation()"
      >
        <div class="menu-header" *ngIf="userDetail">
          <span class="menu-company-name">
            {{
              companyProfile?.company_name ||
                userDetail.first_name + " " + userDetail.last_name
            }}
          </span>
          <span
            class="menu-company-domain"
            [matTooltip]="userDetail.phone_email"
          >
            {{
              userDetail.phone_email.length > 25
                ? (userDetail.phone_email | slice: 0 : 25) + "..."
                : userDetail.phone_email
            }}
          </span>
        </div>
        <div class="menu-divider"></div>
        <a class="menu-item" (click)="selectTab('company-profile')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16" />
            <path d="M12 11h.01" />
            <path d="M12 7h.01" />
            <path d="M12 15h.01" />
            <path d="M8 11h.01" />
            <path d="M8 7h.01" />
            <path d="M8 15h.01" />
            <path d="M16 11h.01" />
            <path d="M16 7h.01" />
            <path d="M16 15h.01" />
          </svg>
          Company Profile
        </a>
        <div class="menu-divider"></div>
        <a class="menu-item logout-menu-item" (click)="onLogout()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Logout
        </a>
      </div>
    </div>
  </div>
</header>
